export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-download-d560d9a3c157863f6a1724ba32443994.svg";